import constants from "./constants";
import appConstants from "../../../../../appConstants";
import { MultiSelectFilter } from "../../../../dataGrid/columnFilters";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getGroupedCustomers(params) {
    return params.data.duplicateCustomers
      .map((customer) => customer.duplicateCustomerName)
      .join(",");
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.MergedCustomerGrid,
      keyColumn: "customerID",
      rowSelection: "single",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Acc #",
          field: "originalCustomerCode",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: constants.columnWidth.CUSTOMER_ACC_NUMBER,
        },
        {
          headerName: "Customer",
          field: "originalCustomerName",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: constants.columnWidth.CUSTOMER_NAME,
          tooltipField: "originalCustomerName",
        },
        {
          headerName: "Aliases #",
          field: "aliasesCount",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: constants.columnWidth.CUSTOMER_ALIASES,
          valueGetter: (params) => params.data.duplicateCustomers.length,
        },
        {
          headerName: "Grouped Customers",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: constants.columnWidth.GROUPED_CUSTOMERS,
          valueGetter: GridConfig.getGroupedCustomers,
          tooltipValueGetter: (params) => params.value,
        },
        {
          headerName: "Address",
          field: "originalCustomerAddress",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: constants.columnWidth.CUSTOMER_ADDRESS,
          tooltipField: "originalCustomerAddress",
        },
        {
          headerName: "City",
          field: "originalCustomerCity",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: constants.columnWidth.CUSTOMER_CITY,
        },
        {
          headerName: "State",
          field: "originalCustomerState",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: constants.columnWidth.CUSTOMER_STATE,
        },
        {
          headerName: "Zip",
          field: "originalCustomerZip",
          cellClass: "gridCell-leftAlign",
          filterFramework: MultiSelectFilter,
          minWidth: constants.columnWidth.CUSTOMER_ZIP,
        },
      ],
    };
  }
}
